module.exports = __webpack_public_path__ + "static/img/KINGSTON_OAK.fbefc9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/KINGSTON_OAK.jpg
// module id = V4vY
// module chunks = 0